import { useEffect, useState } from "react";
import axios from "axios";
import { Button, IconButton, List, ListItem, ListItemIcon, ListItemText, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import { baseUrl } from "../utils/baseUrl";
import { useGlobalAuthContext } from "../context/AuthContext";
import FolderIcon from "@mui/icons-material/Folder";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StandardDialog from "./StandardDialog";
import { getMFPrimaryButtonSx, getMFSecondaryButtonSx } from "../utils/dialogStyles";

const MoveFolderDilogue = ({
  isOpen,
  onClose,
  setReloadFiles,
  itemToMove,
  folders,
  isCopyMode
}) => {
  const theme = useTheme();
  const [loader, setLoader] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [folderData, setFolderData] = useState([]); 

  const { currentUserSessionStorage } = useGlobalAuthContext();

  useEffect(() => {
    if (isOpen && folders) {
      setFolderData([folders]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);


  const getHeaders = () => ({
    Authorization: `Bearer ${currentUserSessionStorage}`,
  });

  const handleSend = async () => {
    setLoader(true);

    try {
      const pathMove = `/savedLayout/edit/${itemToMove?._id}`;
      const pathCopy = `/savedLayout/copy/${itemToMove?._id}`;

      let response = null

      if (isCopyMode)
        response = await axios.post(
          `${baseUrl}${pathCopy}`,
          { parent: selectedItem?._id},
          { headers: getHeaders() }
        );
      else
      response = await axios.put(
        `${baseUrl}${pathMove}`,
        { parent: selectedItem?._id},
        { headers: getHeaders() }
      );

      setLoader(false);

      if (response.status === 201 || response.status === 200) {
        onClose();
        setReloadFiles((prev) => !prev);
      }
    } catch (error) {
      setLoader(false);

   
    }
  };

  const titleText = `${isCopyMode ? "Copy" : "Move"} “${itemToMove?.name ?? ""}”`;

  return (
    <StandardDialog
      open={isOpen}
      onClose={onClose}
      title={titleText}
      idTitle="mf-move-folder-dialog-title"
      headerStart={
        folderData.length > 1 ? (
          <IconButton
            onClick={() => {
              const newArr = [...folderData]; 
              newArr.pop(); 
              setFolderData(newArr);  
            }}
            sx={{ mr: 0.5, mt: -0.25 }}
            aria-label="Back"
            size="small"
          >
            <ArrowBackIcon />
          </IconButton>
        ) : null
      }
      maxWidth="sm"
      footer={
        <>
          <Button
            variant="outlined"
            color="inherit"
            fullWidth
            sx={getMFSecondaryButtonSx()}
            onClick={() => {
              setSelectedItem(null);
              onClose();
            }}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={loader}
            disabled={selectedItem == null}
            onClick={handleSend}
            variant="contained"
            fullWidth
            sx={getMFPrimaryButtonSx(theme)}
          >
            {isCopyMode ? "Copy" : "Move"}
          </LoadingButton>
        </>
      }
    >
      <List dense disablePadding sx={{ mb: 0 }}>
          {folderData[folderData?.length - 1]?.filter((item) => !item.payload)?.map((item, index) => (
            <ListItem
              key={index}
              button
              onClick={() => setSelectedItem(item)}
              onDoubleClick={() => setFolderData([...folderData, item?.children || []])}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                borderRadius: "12px",
                mb: 0.5,
                backgroundColor: selectedItem?._id === item?._id ? "action.selected" : "inherit", 
                "&:hover": {
                  backgroundColor: "action.hover", 
                },
                "&:hover .hover-icon": {
                  opacity: 1,
                },
                transition: "background-color 0.2s", 
              }}
              disabled={itemToMove?._id == item?._id}
            >
              <Stack direction="row" alignItems="center">
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <FolderIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={item?.name} primaryTypographyProps={{ variant: "body2" }} />
              </Stack>
              <ArrowForwardIosIcon
                className="hover-icon"
                sx={{
                  opacity: 0,
                  transition: "opacity 0.2s",
                  fontSize: "1rem",
                }}
              />
            </ListItem>
          ))}
        </List>
    </StandardDialog>
  );
};

export default MoveFolderDilogue;
